import { Clear, KeyboardBackspace } from "@mui/icons-material";
import { IconButton, TextField } from "@mui/material";
import React, { useState } from "react";
import { capitalizeFirst } from "../Utils/functions";
import { useNavigate } from "react-router-dom";
import { addRecentlySearched } from "../../store/recentlySearched";
import { useDispatch } from "react-redux";

const Searchbar = ({ dismissmodals, products, searchpage, onsearchpage }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [hint, sethint] = useState('');

    const [displayeditems, setdisplayeditems] = useState([]);

    const onsearch = (query) => {
        sethint(query)
        if (!query) {
            setdisplayeditems([])
            return;
        }
        const normalizedQuery = query?.toLowerCase().replace(/\s+/g, '');

        if (products?.length > 0) {
            const filtereditems = products.filter((element) => {
                const itemnameMatch = element.item_name?.toLowerCase().replace(/\s+/g, '').includes(normalizedQuery);

                return itemnameMatch;
            });
            setdisplayeditems(filtereditems);
        }
    }


    function separateSentence(sentence, word) {
        // Convert both the sentence and the word to lowercase for case-insensitive matching
        const lowercasedSentence = sentence.toLowerCase();
        const lowercasedWord = word.toLowerCase();

        // Check if the word exists in the sentence
        const wordIndex = lowercasedSentence.indexOf(lowercasedWord);

        if (wordIndex !== -1) {
            // Part of the sentence that contains the word
            const partWithWord = sentence.substring(wordIndex, wordIndex + word.length).trim();

            // Part of the sentence that does not contain the word
            const partWithoutWord = sentence.replace(partWithWord, '').trim();

            return {
                partWithWord: partWithWord,
                partWithoutWord: partWithoutWord,
            };
        } else {
            // If the word is not found in the sentence
            return {
                partWithWord: '',
                partWithoutWord: sentence.trim(),
            };
        }
    }



    function viewProduct(product) {
        dispatch(addRecentlySearched(product));
        navigate('/product/' + product.itemURL, {
            state: { product: product }
        });
    }

    const gotosearch = (e) => {
        if (searchpage) {//if the search bar has been imported from search page screen
            onsearchpage(hint)
        } else {
            e.preventDefault()
            navigate("/itemsearch", { state: { hint: hint } })
        }
    }


    return (
        <div className="searchinputoverlay">
            <div className="pageheader">
                <div className="searchinputdiv">
                    <IconButton onClick={dismissmodals}>
                        <KeyboardBackspace />
                    </IconButton>
                    <form style={{ width: "80%" }} onSubmit={gotosearch} >
                        <input autoFocus={true} className="searchbarinput" value={hint} onChange={(e) => onsearch(e.target.value)} />
                    </form>
                    {hint &&
                        <IconButton onClick={() => sethint('')}>
                            <Clear />
                        </IconButton>
                    }
                </div>
            </div>
            <div className="searchresultsdiv">
                {displayeditems.map((val, key) => {
                    const fword = separateSentence(val.item_name, hint).partWithWord;
                    const sword = separateSentence(val.item_name, hint).partWithoutWord;



                    return (
                        <div key={key} className="wrapsearchresults" onClick={() => viewProduct(val)}>
                            <div><b>{capitalizeFirst(fword)}</b>{sword?.toLowerCase()}</div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Searchbar